import { render, staticRenderFns } from "./ContactoModal.vue?vue&type=template&id=60a810ca&scoped=true"
import script from "./ContactoModal.vue?vue&type=script&lang=js"
export * from "./ContactoModal.vue?vue&type=script&lang=js"
import style0 from "./ContactoModal.vue?vue&type=style&index=0&id=60a810ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a810ca",
  null
  
)

export default component.exports